<template>
    <div
        id="preferiti"
        v-bind:class="[isArticlesModalVisible ? 'bg-light popup-laterale-aperto' : 'bg-light']"
    >
        <vue-headful :title="pageTitle" />
        <div class="body-wrapper">
            <gallery-header />

            <main>
                <div class="container-fluid mt-4">
                    <div class="row align-items-center">
                        <div class="info-album col-md-6 col-lg-8 mt-4">
                            <h2 class="titolo-album text-uppercase mb-0">
                                {{ $t("Preferiti") }}
                            </h2>

                            <p class="numero-foto mb-0 mt-1">
                                {{ numPhotos }} {{ $t("foto") }}
                            </p>
                        </div>

                        <div class="azioni-album col-md-6 col-lg-4 mt-4">
                            <ul class="d-flex justify-content-center justify-content-md-end mb-0">
                                <li v-if="gallery && gallery.orderable">
                                    <a
                                        @click="showArticlesModal({})"
                                        href="javascript:void(0)"
                                        class="btn btn-dark btn-rikorda1 btn-sm pulsante-acquista-tutto"
                                    >
                                        <font-awesome-icon
                                            :icon="['fas', 'shopping-cart']"
                                            class="d--inline"
                                        />
                                        &nbsp;{{ $t("Acquista tutto") }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="visualizzazione-foto mt-5">
                    <div class="container-fluid">
                        <div
                            v-infinite-scroll="loadMore"
                            infinite-scroll-disabled="busy"
                            infinite-scroll-distance="10"
                            class="elenco-foto card-columns"
                        >
                            <!--
                            card-columns è la classe di bootstrap per fare il masonry (per altri tipi di layout bisogna toglierla;
                            posso copiare gli stili messi da questa classe all'elemento e ai suoi child mettendoli nel css tema-01)
                            -->
                            <gallery-photo-card
                                v-for="photo in loadedPhotos"
                                :key="photo.id"
                                :photo="photo"
                                :orderable="isOrderable"
                                @showArticlesModal="showArticlesModal"
                                @photoClicked="showAlbumSlideshow"
                                @favoriteToggle="onFavoriteToggle"
                                @loaded="onPhotoLoaded"
                            ></gallery-photo-card>
                        </div>
                    </div>
                </div>
            </main>

            <gallery-footer />
        </div>

        <b-overlay
            class="overlay"
            :show="isArticlesModalVisible"
            :variant="'dark'"
            :opacity="0.75"
            no-wrap
        >
            <template v-slot:overlay>
                <div></div>
            </template>
        </b-overlay>

        <articles-modal
            ref="articlesModal"
            v-show="isArticlesModalVisible"
            :favorites="true"
            @close="hideArticlesModal"
        />
    </div>
</template>

<script>
import GalleryHeader from "../../components/gallery/Header";
import GalleryFooter from "../../components/gallery/Footer";
import GalleryPhotoCard from "../../components/gallery/PhotoCard";
import ArticlesModal from "../../components/gallery/ArticlesModal";

export default {
    name: "EventFavorites",
    components: {
        GalleryHeader,
        GalleryFooter,
        GalleryPhotoCard,
        ArticlesModal
    },

    data() {
        return {
            galleryUrl: "",
            busy: true,
            title: null,
            pageTitle: null,
            gallery: null,
            photos: [],
            scrollStep: 10,
            loadedPhotos: [],
            isArticlesModalVisible: false,
            loadingCounter: 0,
            maxLoading: 2
        };
    },

    mounted() {
        this.galleryUrl = this.$route.params.galleryUrl;
        this.$api
            .getGalleryFavorites()
            .then((result) => {
                this.gallery = result.gallery;
                this.photos = result.photos;
                this.photos.forEach((photo) => {
                    photo.loadingAllowed = false;
                });
                this.scrollStep = result.scrollStep;
                this.title = this.gallery.title;
                this.albumId = this.gallery.albumId;
                this.setPageTitle();
                this.busy = false;
                this.$nextTick(() => {
                    this.handleLoading(this);
                });
            })
            .catch((error) => {
                console.error("getGalleryFavorites", error);
                this.$router.push({
                    name: "gallery-dashboard",
                    params: { galleryUrl: this.galleryUrl }
                });
            })
            .finally(() => {});
    },

    methods: {
        setPageTitle() {
            if (this.gallery) {
                this.pageTitle = [
                    this.$t("Preferiti"),
                    this.$t("di"),
                    this.gallery.title,
                    "- Rikorda"
                ].join(" ");
            }
        },

        handleLoading(scope) {
            var photosToLoad = scope.loadedPhotos.filter((p) => {
                return !p.loadingAllowed;
            });
            while (
                scope.loadingCounter < scope.maxLoading &&
                photosToLoad.length > 0
            ) {
                var photoToLoad = photosToLoad.shift();
                photoToLoad.loadingAllowed = true;
                scope.loadingCounter++;
            }

            if (
                photosToLoad.length > 0 ||
                scope.loadedPhotos.length < scope.photos.length
            ) {
                setTimeout(scope.handleLoading, 200, scope);
            }
        },

        onPhotoLoaded() {
            this.loadingCounter--;
        },

        loadMore() {
            if (this.loadedPhotos.length < this.photos.length) {
                this.busy = true;

                var start = this.loadedPhotos.length;
                var end =
                    start +
                    Math.min(this.scrollStep, this.photos.length - start);

                this.loadedPhotos.push(...this.photos.slice(start, end));

                this.busy = false;
            }
        },

        showArticlesModal(photo) {
            this.$refs.articlesModal.photoData = photo;
            this.$refs.articlesModal.numPhotos = this.numPhotos;
            this.$refs.articlesModal.selectedArticleQt = 1;

            return this.$refs.articlesModal
                .getPriceSheetData()
                .then((response) => {
                    this.isArticlesModalVisible = response;
                });
        },

        hideArticlesModal() {
            this.isArticlesModalVisible = false;
        },

        showAlbumSlideshow(photoId) {
            this.$router.push({
                name: "gallery-album-photo",
                params: {
                    galleryUrl: this.galleryUrl,
                    albumId: this.gallery.albumId,
                    photoId: photoId
                }
            });
        },

        onFavoriteToggle(photo) {
            if (!photo.isFavorite) {
                var i;
                for (i = 0; i < this.loadedPhotos.length; i++) {
                    if (this.loadedPhotos[i].id === photo.id) {
                        this.loadedPhotos.splice(i, 1);
                        break;
                    }
                }

                for (i = 0; i < this.photos.length; i++) {
                    if (this.photos[i].id === photo.id) {
                        this.photos.splice(i, 1);
                        break;
                    }
                }
            }
        }
    },

    computed: {
        numPhotos() {
            return this.photos ? this.photos.length : 0;
        },

        isOrderable() {
            return this.gallery && this.gallery.orderable;
        }
    }
};
</script>

<style></style>
